// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"AlertPop_ConfirmationPop__7M3du","modalBody":"AlertPop_modalBody__UijzK","modalMessage":"AlertPop_modalMessage__IJxlh","modalButton":"AlertPop_modalButton__YlaW6"};